import { useContext, useEffect, useRef, useState } from "react";
import styles from "./arViewer.module.scss";
import ARViewerCustom from "./ArViewerCustom";
import useIsMobile from "../../../utils/useIsMobile";
import { isAndroid, isIphone } from "../../../helpers/jsHelper";
import CurrentContext from "../../../utils/CurrentContext";
import CloseIcon from "../../../icons/CloseIcon";

function ArViewerWrapperCustom() {
  const [iframeMessage, setIframeMessage] = useState("")
  const {
    loading,
    setLoading,
    isAR,
    setIsAR,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
  } = useContext(CurrentContext);

  const isMobile = useIsMobile();
  const popupRef = useRef(null);

  const handleClose = () => {
    setARModelSrc(null);
    setIsARReady(false);
    setIsAR(false);
    setLoading(false);
    // parentMessageSender({ type: "popup", popupState: false });
  };

  useEffect(() => {
    return () => handleClose();
  }, []);

  useEffect(() => {
    // Handler function for the message event
    const handleMessage = (event) => {
      // console.log(event.data, "event");
      if (event.data !== iframeMessage) {
        setIframeMessage(event.data);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [iframeMessage]);

  useEffect(() => {
    switch (iframeMessage.label) {
      case "arPopup":
        // console.log(iframeMessage.open,"Ar popup")
        iframeMessage.open === true && handleClose();
        break;
      default:
        break;
    }
  }, [iframeMessage]);

  // if (!isARReady || 
  //   (isMobile 
  //     && !isAndroid()
  //   )
  // ) return null;

   useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  if (!isARReady || 
    (isMobile 
      && !isAndroid() 
      && !isIphone()
    )
  ) return null;


  return (
    <div className={styles.ar_wrapper}>
      <div className={styles.ar_model_container} ref={popupRef}>
        <button className={styles.close} onClick={handleClose}>
          <CloseIcon />
        </button>
        <ARViewerCustom />
      </div>
    </div>
  );
}

export default ArViewerWrapperCustom;
